export default __webpack_public_path__ + "static/media/gym-img-01.e163afa5.jpg";